import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeTaskDetailReport } from './Pages';

export const EmployeeTaskDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeTaskDetailReport} />
       
    </Fragment>
)